import axios from "axios";
import apiURI from "./Api";

// Comissão por compartilhamento: um token por par (usuário, produto), sem expiração.
// Só usuários do plano Promoter recebem a comissão; o backend não bloqueia os outros.
export default class ShareService {
  // 200001 com result.token, ou 500183 se o usuário ainda não tem link para o produto.
  async getSharePermission(productid, token, username) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/share/get/${productid}/username/${username}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  // 200000 com result.token, ou 500184 se o link já existe (use getSharePermission).
  async postShareCreate(productid, token, username) {
    const response = await axios({
      method: "post",
      data: { productid, username },
      url: `${apiURI}/share/create`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  // Sem auth. Só o primeiro clique de cada link vale um bônus ao Promoter; não afeta a comissão.
  async postShareClick(shareToken) {
    const response = await axios({
      method: "post",
      data: { token: shareToken },
      url: `${apiURI}/share/click`,
    });

    return response.data;
  }

  // Devolve o token do link do usuário para o produto, criando se ainda não existir.
  async getOrCreateShareToken(productid, token, username) {
    const readToken = async () => {
      const res = await this.getSharePermission(productid, token, username);
      return res?.messageCode === 200001 ? res.result?.token ?? null : null;
    };

    const existing = await readToken().catch(() => null);
    if (existing) return existing;

    const created = await this.postShareCreate(productid, token, username);
    if (created?.messageCode === 200000 && created.result?.token) return created.result.token;
    if (created?.messageCode === 500184) return readToken();

    throw new Error(`share/create failed: ${created?.messageCode}`);
  }
}
